import React from 'react';
import { LoadingDots } from '@workday/canvas-kit-react/loading-dots';
import styles from './loading-fallback.module.scss';
import { autoId } from '@workday/upc-common';

export const FallBack = () => (
    <div className={styles.fallback} {...autoId('fallback')}>
        <LoadingDots role='progressbar' />
    </div>
);
